var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 15 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.375 0v1.25h3.476L8.301 5.8 9.2 6.7l4.55-4.55v3.476H15V0zM0 0v5.625h1.25V2.15l4.55 4.55.9-.898-4.551-4.552h3.476V0zm8.301 9.2 4.55 4.55H9.375V15H15V9.375h-1.25v3.476L9.2 8.301zM1.249 12.85V9.375H0V15h5.625v-1.25H2.15l4.55-4.55L5.8 8.3z",
  clipRule: "evenodd"
})));
export { SvgExpand as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvZXhwYW5kLjVkOWVkZGQxLnN2ZyI7";